export class AlreadyCancelledTradeTransactionsError extends Error {
  static create(errorMessage) {
    return new AlreadyCancelledTradeTransactionsError(errorMessage)
  }
}
